import { createFileRoute } from "@tanstack/react-router"

import { DeveloperPortal } from "~/components/Developers/DeveloperPortal"
import CustomHead from "~/components/SEOHead/CustomHead"
import MarketingLayout from "~/layouts/MarketingLayout"

export const Route = createFileRoute("/developers")({
  component: DevelopersPage,
})

function DevelopersPage() {
  return (
    <MarketingLayout>
      <CustomHead
        title="VidMax Developer Platform — API, OpenAPI, MCP, CLI"
        description="Connect agents and applications to VidMax with the public REST API, OpenAPI contract, hosted MCP server, CLI, and creative skill."
        url="https://vidmax.ai/developers"
      />
      <DeveloperPortal />
    </MarketingLayout>
  )
}
